// A2-540 (operator 2026-10-26, NL Q1 test data): a reverse-charged sale whose
// invoice showed VAT had that VAT dropped from the return with only a
// non-blocking card, and the form said "Ready to file". VAT shown on an
// invoice is owed until a credit note corrects it (Art 203; NL Wet OB art.37).
// The server names it (api/_invoiced_vat_gate) and holds "ready to file" while
// the card is unanswered; this says so in one line, with the way to the card.
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useReviewCardHref } from "./reviewCardLink";   // A2-581 lead 6

const money = (ccy, v) => {
  const n = Number(v);
  return `${ccy} ${Number.isFinite(n) ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : v}`;
};

export const InvoicedVatNote = ({ data }) => {
  const { t } = useTranslation();
  const cardHref = useReviewCardHref(data?.flag);
  if (!data || !data.count) return null;
  const vat = Object.entries(data.vat_by_currency || {}).map(([c, v]) => money(c, v)).join(" + ");
  const open = data.open > 0;
  return (
    <div data-testid="invoiced-vat-note" data-open={open ? "true" : "false"}
      className={`text-sm rounded-lg p-3 mb-4 border ${open
        ? "text-red-900 dark:text-red-100 bg-red-50 dark:bg-red-950/40 border-red-500 dark:border-red-700"
        : "text-amber-900 dark:text-amber-100 bg-amber-50 dark:bg-amber-950/40 border-amber-400 dark:border-amber-700"}`}>
      {t("ui.country_return.invoiced_vat.line", {
        vat, count: data.count,
        defaultValue: `${vat} of VAT shown on ${data.count} reverse-charged invoice(s) is not on this return. It is owed until a credit note corrects the invoice.`,
      })}{" "}
      {open ? (
        <Link to={cardHref} data-testid="invoiced-vat-open-card"
          className="font-semibold underline">
          {t("ui.country_return.invoiced_vat.open_card", { defaultValue: "Answer the card on Step 4" })}
        </Link>
      ) : (
        <span>{t("ui.country_return.invoiced_vat.answered", { defaultValue: "Answered on Step 4." })}</span>
      )}
    </div>
  );
};
